import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';
import { LoadablePaint } from '@confluence/loadable';

const ShareableLinkSpaceAdminControlsLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSpaceAdminControls" */ '@confluence/shareable-links/entry-points/ShareableLinkSpaceAdminControls.tsx'
			)
		).ShareableLinkSpaceAdminControls,
});

export const ShareableLinkSpaceSettingsRoute = () => {
	return <ShareableLinkSpaceAdminControlsLoader />;
};

ShareableLinkSpaceSettingsRoute.NAVIGATION_PARAMS = ({ name }: RouteMatch) => ({
	Screen: {
		screenEvent: {
			name: 'spaceSettingsShareableLinksScreen',
			attributes: {
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: {
			routeName: name,
		},
	},
	MainLayout: true,
	BannerContext: { includeTopNav: true },
});
